import {MI} from "../init";
import {getRandomInt} from "../../framework/src/helpers";

/**
 * @abstract
 * @constructor
 */
export function PreinfoSlide() {

	/** @type {MadnesObject} */
	this._btn;

	/** @type {MadnesObject} */
	this._btnShine;

	/** @type {SpinReels} */
	this._spinReels;

	/** @type {ReelsSpinner} */
	this._reelsSpinner;

	/** @type {SymbolsManager} */
	this._symbolsManager;

	/** @type {Object<MadnesTween>} */
	this._tweens = {};

//	this._btnLocked = false;

	this._symbScale = 0.5;

	this._animRunning = false;

	/** @type {Array<MadnesObject>} */
	this._animsSymbols = [];
}

PreinfoSlide.prototype._createBtns = function(x, y, frameName) {

	this._btn = MI.addImg(x, y, "preinfo_atlas").setFrameName(frameName);
	this._btn.setAnchor(0.5, 0.5);

	this._btnShine = MI.addImg(x, y, "preinfo_atlas").setFrameName(frameName + "_active");
	this._btnShine.setAnchor(0.5, 0.5);
	this._btnShine.setVisible(false);
	this._btnShine.setBlend("ADD");
};

PreinfoSlide.prototype._getServerReels = function ()
{
	var reels = [];

	for(var i = 0; i < 5; i++) {
		var reel = [];
		for(var j = 0; j <= 5; j++) {
			reel.push(getRandomInt(0, 10));
		}
		reels.push(reel);
	}

	return reels;
};

/**
 * @returns {MadnesObject}
 */
PreinfoSlide.prototype.getBtn = function() {
	return this._btn;
};

/**
 * @returns {MadnesObject}
 */
PreinfoSlide.prototype.getBtnShine = function() {
	return this._btnShine;
};

PreinfoSlide.prototype.setOnBtnClick = function(func) {
	var _self = this;
	this._btn.onInputDown(function() {

//		if(_self._btnLocked) {
//			return;
//		}

		_self.setActive(true);
		func();
	});
};

PreinfoSlide.prototype._stopSpin = function() {

	this._spinReels.getReel(0).stop();

	this._spinReels.getReel(1).addSymbolsToStop(2);
	this._spinReels.getReel(1).stop();

	this._spinReels.getReel(2).addSymbolsToStop(4);
	this._spinReels.getReel(2).stop();

	this._spinReels.getReel(3).addSymbolsToStop(6);
	this._spinReels.getReel(3).stop();

	this._spinReels.getReel(4).addSymbolsToStop(8);
	this._spinReels.getReel(4).stop();
};

/**
 * @param {Array<MadnesObject>} resSymbols
 * @param {number=} multi
 * @returns {Promise}
 */
PreinfoSlide.prototype._playWinAnim = function(resSymbols, multi) {

	var _self = this;

	this._animsSymbols = this._symbolsManager.createAnimsSymbols(resSymbols);

	for(var i = 0; i < this._animsSymbols.length; i++) {
		this._animsSymbols[i].setScale(0.5, 0.5);
		this._animsSymbols[i].createWinSymbol(multi ? true : false);

		if(multi) {
			this._animsSymbols[i].createMulti(16);
		}

		this._animsSymbols[i].setVisible(true);
		resSymbols[i].setVisible(false);
	}

	var anims = [];

	for(var i = 0; i < this._animsSymbols.length; i++) {
		anims.push(this._animsSymbols[i].playWinAnim());

		if(multi) {
			anims.push(this._animsSymbols[i].playMulti());
		}
	}

	return Promise.all(anims).then(function() {

		for(var i = 0; i < _self._animsSymbols.length; i++) {
			_self._animsSymbols[i].removeWinAnim();

			if(multi) {
				_self._animsSymbols[i].removeMulti();
			}
			_self._animsSymbols[i].destroy();
			resSymbols[i].setVisible(true);
		}

		_self._animsSymbols.length = 0;
	});
};

PreinfoSlide.prototype._setBtnActive = function() {

	var _self = this;

//	this._btnLocked = true;

	this._stopBtnTween();

	_self._btnShine.setAlpha(1);
	_self._btnShine.setScale(1, 1);
	_self._btnShine.setVisible(true);

	this._tweens["btn_shine_alpha"] = MI.addTween().to(this._btnShine, { 'alpha': 0 }, {
		'duration': 500
	});

	this._tweens["btn_shine_scale"] = MI.addTween().to(this._btnShine,
	{ 'x': 1.3, 'y': 1.3 }, {
		'scale': true,
		'duration': 500,
		'callback': function() {
			_self._btnShine.setVisible(false);
//			_self._btnLocked = false;
		}
	});
};

PreinfoSlide.prototype._stopBtnTween = function() {
	for(var key in this._tweens) {
		this._tweens[key].stop();
	}
};

PreinfoSlide.prototype._destroyBtns = function() {

	this._btn.destroy();
	this._btnShine.destroy();
};

PreinfoSlide.prototype._destroyAnims = function() {

	for(var i = 0; i < this._animsSymbols.length; i++) {
		this._animsSymbols[i].removeMulti();
		this._animsSymbols[i].removeWinAnim();
		this._animsSymbols[i].destroy();
	}

	this._animsSymbols.length = 0;
};

/**
 * @abstract
 */
PreinfoSlide.prototype.setActive = function(bool) {};